import { createNumberFormat } from '@shared/utils/numberFormat.ts';

const CURRENCY_SYMBOL = '€';
const MAX_FRACTION_DIGITS = 2;

const getMoneyNumberFormat = (minFractionDigits: number) => {
  return createNumberFormat({
    useGrouping: 'always',
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: Math.max(MAX_FRACTION_DIGITS, minFractionDigits),
  });
};

export function formatNumberAsMoney(n: number, minFractionDigits: number = 0) {
  return `${CURRENCY_SYMBOL} ${getMoneyNumberFormat(minFractionDigits).format(n)}`;
}
